import { render, staticRenderFns } from "./WorkspaceLayout.vue?vue&type=template&id=6ae91352&"
import script from "./WorkspaceLayout.vue?vue&type=script&lang=js&"
export * from "./WorkspaceLayout.vue?vue&type=script&lang=js&"
import style0 from "./WorkspaceLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports